import { Snack, Div, Span, Button } from "@tblabs/truffle";
import { CloseIcon } from "./CloseIcon";


export class Notification extends Snack
{
    constructor(title: string, content: string | undefined, autoCloseTimeout: number = 3500)
    {
        super(
            new Div("cart-notification").Style("will-change: transform, opacity; opacity: 1; transform: none;").Append(
                new Div("cart-notification__header").Append(
                    new Div("cart-notification__header-content").Append(
                        new Span(title).Class("cart-notification__header-title")
                    ),
                    new Button("").Class("cart-notification__close")
                        .Append(new CloseIcon())
                        .OnClick(() => this.Close())
                ),
                new Div("cart-notification__body").Append(
                    new Div("cart-notification__item-details").Append(
                        content && new Div().Text(content)
                    )
                )
            ),
            "",
            { clickAnywhereToClose: true, autoCloseTimeout: autoCloseTimeout }
        );
    }
}
